const headerData = [
  {
    title: "Products",
    url: "/products",
    _type: "linksWithCategoryType",
    width: 407,
    category: [
      {
        _type: "categoryType",
        categoryTitle: "Prisma ORM",
        links: [
          {
            subtitle: "Write Queries the way you think",
            _type: "linkType",
            icon: "terminal",
            title: "Client",
            external: false,
            url: "/client",
          },
          {
            subtitle: "Generate customizable SQL migrations",
            _type: "linkType",
            icon: "arrows-rotate",
            title: "Migrate",
            external: false,
            url: "/migrate",
          },
        ],
      },
      {
        _type: "categoryType",
        categoryTitle: "Prisma Data Platform",
        links: [
          {
            _type: "linkType",
            icon: "bolt",
            title: "Accelerate",
            external: false,
            url: "/data-platform/accelerate",
            subtitle: "Query up to 1000x faster",
          },
          {
            title: "Pulse",
            external: false,
            url: "/data-platform/pulse",
            subtitle: "Real-time database events",
            _type: "linkType",
            icon: "signal-stream",
            tag: "Early Access",
          },
        ],
      },
    ],
  },
  {
    _type: "linkType",
    title: "Pricing",
    url: "/pricing",
    external: false,
  },
  {
    title: "Resources",
    url: "/resources",
    _type: "arrayOfLinksType",
    width: 870,
    hidePlaygroundWidth: 536,
    links: [
      {
        _type: "linkType",
        icon: "book-open-cover",
        title: "Documentation",
        url: "/docs",
        external: false,
      },
      {
        _type: "linkType",
        icon: "chart-line-up",
        title: "Get started",
        url: "/docs/getting-started",
        external: false,
      },
      {
        title: "Tutorials",
        url: "/learn",
        external: false,
        _type: "linkType",
        icon: "clapperboard-play",
      },
      {
        _type: "linkType",
        icon: "message-code",
        title: "Examples",
        external: true,
        url: "https://github.com/prisma/prisma-examples",
      },
      {
        title: "Prisma in your stack",
        url: "/stack",
        external: false,
        _type: "linkType",
        icon: "layer-group",
      },
       {
        icon: "globe",
        title: "Ecosystem",
        url: "/ecosystem",
        external: false,
        _type: "linkType",
      },
      {
        _type: "linkType",
        icon: "users",
        title: "Customer stories",
        url: "/showcase",
        external: false,
      },
      {
        title: "Data guide",
        url: "/dataguide",
        external: true,
        _type: "linkType",
        icon: "file-binary",
      },
    ],
    playground: {
      _type: "promoLinkType",
      img: "https://prisma.io/blog/blog/header/dev-hub.svg",
      title: "Playground",
      url: "https://playground.prisma.io/",
      padding: `8px 16px 0 16px`,
      external: false
    }
  },
  {
    _type: "linkType",
    title: "Blog",
    external: false,
    url: "/blog",
  },
];

export default headerData;
